import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Trusteapi } from '../interfaces/trusteapi';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor() {}

  getToken() {
    const auth = this.getAuth();
    return auth ? auth.token.token : null;
  }
  getTokenInfo() {
    const auth = this.getAuth();
    return auth ? auth.tokenInfo : null;
  }

  checkOtpStatus(callback) {
    const auth = this.getAuth();
    return auth.otp.request(callback);
  }

  requestOtpOption(callback, type) {
    const auth = this.getAuth();
    return auth.otp.request(callback, type);
  }

  sendOtpCode(callback, type, code) {
    const auth = this.getAuth();
    return auth.otp.request(callback, type, code);
  }

  getAuth() {
    const trusteapi = <Trusteapi>(window as any)['trusteapi'];
    if (trusteapi === null) {
      return null;
    }
    return trusteapi.auth === null ? null : trusteapi.auth;
  }

  logout() {
    const element: HTMLAnchorElement = document.createElement('a');
    element.style.display = 'none';
    document.body.appendChild(element);
    element.href = `${environment.baseUrl}/logout`;
    element.click();
    element.remove();
  }
}
